<template>
	<div>
		<!-- innehåll -  -->

		<h3>Varumärken</h3>

		<div id="header" class="flexcenter"
			style="">

			<div style="flex-grow:1;width:100%;">
				<div class="flexcenter" style="background:white;max-width:400px;padding:3px;border-radius: 5px;">
					<input type="text" placeholder="Sök bland varumärken" v-model="this.filter" style="width:100%;outline: none;border:0px solid transparent;" />
					<Circle fileName="w3_close_white" size="15px" padding="20%" color="--grey-5" @click="this.filter = '' " />
				</div>

			</div>

			<div v-if="this.productTypeFilter" class="flexcenter">
				<div class="filter link" :class="this.filterMc ? 'selected' : '' " @click="this.filterMc = !this.filterMc">MC
				</div>

				<div class="filter link" :class="this.filterCykel ? 'selected' : ''"
					@click="this.filterCykel = !this.filterCykel">CYKEL
				</div>
				<div class="filter link" :class="this.filterOlja ? 'selected' : ''" @click="this.filterOlja = !this.filterOlja">
					OLJA
				</div>
			</div>
		</div>

		<div style="padding:0px;background:var(--grey-2);width:100%;border-radius: 5px;">
			<div id="manufactorGrid">

				<div v-for="(manufactor, index) in this.baseManufactorListAll" :key="manufactor.manufactorId + '_' + index"
					class="manufactor link" style="padding:3px;border-radius:5px;position: relative;"
					@click="this.$emit('searchManufactorSelected', manufactor)"
					@mouseenter="this.manufactorId = manufactor.manufactorId" @mouseleave="this.manufactorId = null">

					<div class="productType" v-if="this.productTypeLabel && this.manufactorId == manufactor.manufactorId"
						style="position:absolute;padding:0px;width:calc(100% - 10px);text-align: right;">
						<div style="background-color: var(--grey-3);padding:3px;font-size:70%;border-radius: 3px;display: inline;">
							{{ this.productTypeLabel(manufactor) }}
						</div>

					</div>
					<div style="display:flex;align-items:center;background:white;height: 100%; "
						:title="this.productTypeTitle(manufactor) ">
						<img :src="this.src(manufactor)" style="width:100%;object-fit: contain;" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import listHelper from '../../helper/list-helper';
import settings from '../../settings';
import { STORE_GETTER } from '../../store/store';


//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";

export default {
	name: "PopoverManufactorView",
	components: {},
	mixins: [],
	props: {
		productTypeFilter: Boolean
	},
	data() {
		return {
			manufactorId:null,
			filterMc: null,
			filterCykel: null,
			filterOlja: null,
			filter: null,
		};
	},
	computed: {

		/*baseManufactorListAll() {

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL];

			if (baseModel && baseModel.manufactorList) {
				return baseModel.manufactorList
			}

			return null;
		}, */
		baseManufactorListAll() {

			var  manufactorList = null;

			if (this.productTypeFilter){

				manufactorList = this.$store.getters[STORE_GETTER.MANUFACTOR_LIST_ALL];

				if (this.hasFilter) {
					manufactorList = manufactorList.filter(manufactor => {
						if (this.filterMc && manufactor.pt == 1) {
							return true;
						}

						if (this.filterCykel && manufactor.pt == 2) {
							return true;
						}

						if (this.filterOlja && manufactor.pt == 3) {
							return true;
						}

						return false;
					})
				}
				
			}else{
				manufactorList = this.$store.getters[STORE_GETTER.MANUFACTOR_LIST]?.filter(manufactor => manufactor != null); 
			}
			

	

			if (this.filter) {
				manufactorList = listHelper.filterList(manufactorList, this.filter)
			}


			return manufactorList;
		},

		hasFilter() {
			if (this.filterMc && this.filterCykel && this.filterOlja) {
				return false;
			}

			return this.filterMc || this.filterCykel || this.filterOlja

		},


	},
	watch: {
		
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });
		src(manufactor){
			
				return settings.manufactorLogoPath + manufactor.manufactorId + ".jpg"
			
		},
		productTypeLabel(manufactor){
			if (manufactor.pt == 1){
				return "MC";
			}else if(manufactor.pt == 2){
				return "CYKEL";
			}else if(manufactor.pt == 3){
				return "OLJA"
			}

			return null;


		},
		productTypeTitle(manufactor){

			if (manufactor.pt == 1) {
				return "Klicka för alla mc-produkter från " + manufactor.name;

			} else if (manufactor.pt == 2) {
				return "Klicka för alla cykelprodukter från " + manufactor.name;

			} else if (manufactor.pt == 3) {
				return "Klicka för alla olja- och smörjprodukter från " + manufactor.name;

			}

			return null;

			
		}

	},
	created() {

	}
};
</script>

<style scoped>

div#manufactorGrid{
	display: grid;
	grid-template-columns: repeat(6, calc((100% - 25px) / 6));
	grid-row: auto ;
	column-gap: 5px;
	row-gap: 5px;
	border:5px solid transparent;
	align-items: stretch;
	
}

div#manufactorGrid div.manufactor {
	background:white;
	
}



@media (max-width: 768px) {


	div#manufactorGrid {
			display: grid;
			grid-template-columns: auto auto auto;
			grid-auto-rows: 80px;
		}

		div#manufactorGrid div.manufactor.link div img {
			width: 100%;
			object-fit: contain;
			height:60px;

		}
}

div#header{
	padding: 0px;
		background: var(--grey-2);
		width: calc(100% - 20px);
		border-radius: 5px;
		padding: 5px;
		margin-bottom: 10px;
		margin-top: 10px;
	
}

@media (max-width: 768px) {


	div#header {
		flex-direction: column;
		row-gap: 5px;
		align-items: start;
		width: calc(100% - 10px);
	}


}

div.filter {
	background: white;
	padding: 5px;
	padding-left: 10px;
	padding-right: 10px;
	border-radius: 5px;
	font-weight: bold;
	font-size: 90%;

}

div.filter:hover {
	background: var(--grey-3);

}

div.filter.selected {
	background: var(--grey-4);
	

}

</style>